module.exports = "<!-- Topbar Start -->\n<div class=\"navbar-custom d-md-none\">\n    <button class=\"button-menu-mobile open-left disable-btn\">\n        <i class=\"mdi mdi-menu\"></i>\n    </button>\n</div>\n<!-- end Topbar -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/mobile-bar/mobile-bar.component.html
// module id = ./src/app/components/partials/mobile-bar/mobile-bar.component.html
// module chunks = main